var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "27", height: "44", viewBox: "0 0 27 44", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.87183 5.06066C4.32788 4.47487 4.32788 3.52513 4.87183 2.93934C5.41577 2.35355 6.29768 2.35355 6.84162 2.93934L21.6988 18.9393C22.2427 19.5251 22.2427 20.4749 21.6988 21.0607L6.84162 37.0607C6.29768 37.6464 5.41577 37.6464 4.87183 37.0607C4.32788 36.4749 4.32788 35.5251 4.87183 34.9393L18.7441 20L4.87183 5.06066Z", fill: "#fff", filter: "url(#id-50a)" }),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "id-50a", x: ".464", y: ".5", width: "25.643", height: "43", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
        React.createElement("feOffset", { dy: "2" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_560_5228" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow_560_5228", result: "shape" })
      )
    )
  );
});